import React, { PropsWithChildren } from 'react'
import { useMediaQuery } from '../../hooks/useMediaQuery'
import { ItemType } from '../../slices/LogoGrid'
import ResponsiveSlider from './ResponsiveSlider'
import classes from './logoList.module.scss'

export interface ILogoListProps {
  title: string
  data: ItemType[]
  light_bg: boolean
}

const LogoList: React.FC<PropsWithChildren<ILogoListProps>> = ({ title, data, children, light_bg }) => {
  const isMobile = useMediaQuery('(max-width: 1279px)')

  return data?.length > 0 ? (
    <div className={classes.generalContainer}>
      <h1 className={classes.logoListTitle}>{title}</h1>
      {isMobile ? (<ResponsiveSlider light_bg={light_bg} data={data}/>):(<>{children}</>)}

    </div>

  ) : null
}

export default LogoList
